export default "__VITE_ASSET__7bb689d5__"